// extracted by mini-css-extract-plugin
export default {"heading":"Partners_heading__hORWc","slider":"Partners_slider__qUkwZ","slide":"Partners_slide__YekSa"};